module.exports = __webpack_public_path__ + "static/media/mousecursor.f7b31ecb.png";